exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style-module__wrap___2tMEr{font-size:16px}@media (min-width: 480px){.style-module__wrap___2tMEr{font-size:16.888888889px}}.style-module__negative-margin___1yBbW{margin:0 -20px}\n", ""]);

// exports
exports.locals = {
	"wrap": "style-module__wrap___2tMEr",
	"negative-margin": "style-module__negative-margin___1yBbW"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss"}!./src/components/NewScoreModal/style.module.scss
// module id = 1753
// module chunks = 0